import { Badge } from '@/components/ui/badge'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const teamColumns: GridColumn[] = [
  {
    title: 'Name',
    field: 'name',
    show: true,
    sortable: false,
  },
  {
    title: 'Company',
    field: `tickmillCompany.name`,
    show: true,
    sortable: false,
  },
  {
    title: 'Region',
    show: true,
    sortable: false,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem.region) {
        return <td />
      }
      return (
        <td>
          <Badge variant='outline-primary'>{props.dataItem.region.name}</Badge>{' '}
        </td>
      )
    },
  },
  {
    title: 'Country',
    show: true,
    sortable: false,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem.country) {
        return <td />
      }
      return (
        <td>
          <Badge variant='outline-info'>{props.dataItem.country.name}</Badge>
        </td>
      )
    },
  },
]

export default teamColumns
